import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap/lib';
import { Icon } from 'semantic-ui-react';
import React, { PureComponent } from 'react';
import GenericSidebar from '../GenericSidebar';
import logo from '../../assets/logo.png';
import buildMenu from './menuBuilder';
import DashboardSublist from './DashboardSublist';
import './DashboardSidebar.scss';

const sidebarStyle = {
  height: '100%',
  overflow: 'hidden',
  backgroundColor: '#393f4f',
  maxWidth: '320px',
  minWidth: '200px',
  width: '17%',
  zIndex: 1,
  transition: '0.5s',
};

class DashboardSidebar extends PureComponent {
  renderMenuItem = (item) => {
    const { user, openSubMenu } = this.props;
    if (item.subMenu && openSubMenu === item.name) {
      return (
        <DashboardSublist
          subItems={item.subList}
          user={user}
          subMenuName={item.name}
          key={item.name}
        />
      );
    }
    const url = item.getUrl(this.props.user);
    return (
      <LinkContainer to={url} key={url}>
        <div className="sidebar-list-item" key={item.name}>
          <p>
            <Icon name="unordered list" className="sidebar-list-icon" />
            {item.name}
          </p>
        </div>
      </LinkContainer>
    );
  };

  render() {
    const { opened, toggle, user, currentUserDealer } = this.props;
    const menu = buildMenu(user, currentUserDealer);
    return (
      <GenericSidebar opened={opened} toggle={toggle} style={sidebarStyle}>
        <div className="logo-container">
          <Link to="/">
            <img src={logo} alt="Logo" className="logo" />
          </Link>
        </div>

        {menu.map(this.renderMenuItem)}
      </GenericSidebar>
    );
  }
}

DashboardSidebar.propTypes = {
  user: PropTypes.object,
  opened: PropTypes.bool,
  toggle: PropTypes.func,
  openSubMenu: PropTypes.string,
  currentUserDealer: PropTypes.object,
};

export default withRouter(DashboardSidebar);
